module.exports = __webpack_public_path__ + "img/icon_before.68538852.svg";